export const FILES_COLLECTION_NAME: string = "directus_files";
